import { API_URL } from '../../../app-config/constants';
import { SurveyDate, SurveyDates } from '../../../types/SurveyResponses';
import { get } from '../request';

const ENTRY = `${API_URL}/surveys`;

getDates.operation = 'READ';
export function getDates(surveyId: string): Promise<SurveyDates> {
    return get<SurveyDate[]>(`${ENTRY}/${surveyId}/dates`).then(dates => ({
        id: surveyId,
        dates,
    }));
}
